/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-one-expression-per-line */
import {
  CarOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  CoffeeOutlined,
  EyeOutlined,
  LoadingOutlined,
  ProjectOutlined,
  ToolOutlined,
} from '@ant-design/icons'
import React from 'react'

import InfiniteScroll from 'react-infinite-scroll-component'
import { useTaskBreak } from '~/hooks/Tasks/Kanban/useTaskBreak'
import { useTaskCanceled } from '~/hooks/Tasks/Kanban/useTaskCanceled'
import { useTaskEnRoute } from '~/hooks/Tasks/Kanban/useTaskEnRoute'
import { useTaskFinished } from '~/hooks/Tasks/Kanban/useTaskFinished'
import { useTaskReceived } from '~/hooks/Tasks/Kanban/useTaskReceived'
import { useTaskWorking } from '~/hooks/Tasks/Kanban/useTaskWorking'
import { LoadingIndicator } from '~/pages/Tasks/ShowTasks/styles'
import { translate } from '~/utils/locale'

import CardsKanban from '../Cards'

import { Container, Boards, Board, Wrapper } from './styles'
import { useTaskViewed } from '~/hooks/Tasks/Kanban/useTaskViewed'
import { useTaskCheckIn } from '~/hooks/Tasks/Kanban/useTaskCheckIn'
import { Avatar, Flex, Tag, Typography } from 'antd'

const ListKanban: React.FC = () => {
  const { taskReceived, isLoading, loadDataReceived, tasksReceivedTotal } =
    useTaskReceived()
  const {
    taskViewed,
    isLoading: isLoadingViewed,
    loadDataViewed,
    tasksViewedTotal,
  } = useTaskViewed()
  const { taskCheckIn, isLoading: isLoadingCheckIn } = useTaskCheckIn()
  const {
    taskEnRoute,
    tasksEnRouteTotal,
    loadDataEnRoute,
    isLoading: isLoadEnRoute,
  } = useTaskEnRoute()
  const {
    taskWorking,
    tasksWorkingTotal,
    loadDataWorking,
    isLoading: isLoadWork,
  } = useTaskWorking()
  const {
    taskBreak,
    tasksBreakTotal,
    loadDataBreak,
    isLoading: isLoadBreak,
  } = useTaskBreak()
  const {
    taskCanceled,
    tasksCanceledTotal,
    loadDataCanceled,
    isLoading: isLoadCancel,
  } = useTaskCanceled()
  const {
    taskFinished,
    tasksFinishedTotal,
    loadDataFinished,
    isLoading: isLoadFinish,
  } = useTaskFinished()

  if (
    isLoading ||
    !taskReceived ||
    isLoadBreak ||
    !taskBreak ||
    isLoadEnRoute ||
    !taskEnRoute ||
    isLoadWork ||
    !taskWorking ||
    isLoadCancel ||
    !taskCanceled ||
    isLoadFinish ||
    !taskFinished ||
    isLoadingViewed ||
    !taskViewed ||
    isLoadingCheckIn ||
    !taskCheckIn
  ) {
    return (
      <LoadingIndicator>
        <LoadingOutlined style={{ fontSize: 64, margin: 'auto' }} spin />
      </LoadingIndicator>
    )
  }

  const isColumns = JSON.parse(localStorage.getItem('kanbanConfigurations')!)
  const isCode = isColumns?.data_pattern?.includes('code')

  const size = isColumns?.data_pattern?.length

  return (
    <Container>
      <Boards>
        <Wrapper>
          <div>
            <div className="title">
              <Flex align="center" gap={10}>
                {isCode && size === 1 ? (
                  ''
                ) : (
                  <Avatar
                    shape="square"
                    icon={<ProjectOutlined style={{ fontSize: 14 }} />}
                    size={25}
                    style={{ background: '#096dd9' }}
                  />
                )}
                <Typography.Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksOptionsKanbanList.receivedText')}
                </Typography.Title>
              </Flex>
              <Tag color="#096dd9">
                {tasksReceivedTotal}{' '}
                {translate('TasksOptionsKanbanList.tasksText')}
              </Tag>
            </div>
          </div>
          <InfiniteScroll
            dataLength={taskReceived.length}
            hasMore={taskReceived.length !== tasksReceivedTotal}
            next={loadDataReceived}
            loader={<LoadingOutlined />}
            scrollableTarget="scrollableDiv"
            height={'70vh'}
            className="teste"
          >
            <Board id="scrollableDiv" isCode={isCode && size === 1}>
              <div className="cards" id="teste">
                {taskReceived?.map((taskStatus) => (
                  <CardsKanban
                    taskStatusData={taskStatus}
                    key={taskStatus._id}
                  />
                ))}
              </div>
            </Board>
          </InfiniteScroll>
        </Wrapper>

        <Wrapper>
          <div>
            <div className="title" id="viewed">
              <Flex align="center" gap={10}>
                {isCode && size === 1 ? (
                  ''
                ) : (
                  <Avatar
                    shape="square"
                    icon={<EyeOutlined style={{ fontSize: 14 }} />}
                    size={25}
                    style={{ background: '#2db7f5' }}
                  />
                )}
                <Typography.Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksOptionsKanbanList.viewedText')}
                </Typography.Title>
              </Flex>
              <Tag color="#2db7f5">
                {tasksViewedTotal}{' '}
                {translate('TasksOptionsKanbanList.tasksText')}
              </Tag>
            </div>
          </div>
          <InfiniteScroll
            dataLength={taskViewed.length}
            hasMore={taskViewed.length !== tasksViewedTotal}
            next={loadDataViewed}
            loader={<LoadingOutlined />}
            scrollableTarget="scrollableDiv"
            height={'70vh'}
            className="teste"
          >
            <Board id="scrollableDiv" isCode={isCode && size === 1}>
              <div className="cards">
                {taskViewed?.map((taskStatus) => (
                  <CardsKanban
                    taskStatusData={taskStatus}
                    key={taskStatus._id}
                  />
                ))}
              </div>
            </Board>
          </InfiniteScroll>
        </Wrapper>

        {/* <Wrapper>
          <div>
            <div className="title">
              <Flex align="center" gap={10}>
                {isCode && size === 1 ? (
                  ''
                ) : (
                  <Avatar
                    shape="square"
                    icon={<ProjectOutlined style={{ fontSize: 14 }} />}
                    size={25}
                    style={{ background: '#096dd9' }}
                  />
                )}
                <Typography.Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksOptionsKanbanList.acceptedText')}
                </Typography.Title>
              </Flex>
              <Tag color="#096dd9">
                {tasksCheckInTotal}{' '}
                {translate('TasksOptionsKanbanList.tasksText')}
              </Tag>
            </div>
          </div>
          <InfiniteScroll
            dataLength={taskCheckIn.length}
            hasMore={taskCheckIn.length !== tasksCheckInTotal}
            next={loadDataCheckIn}
            loader={<LoadingOutlined />}
            scrollableTarget="scrollableDiv"
            height={'70vh'}
            className="teste"
          >
            <Board id="scrollableDiv" isCode={isCode && size === 1}>
              <div className="cards">
                {taskCheckIn?.map((taskStatus) => (
                  <CardsKanban
                    taskStatusData={taskStatus}
                    key={taskStatus._id}
                  />
                ))}
              </div>
            </Board>
          </InfiniteScroll>
        </Wrapper> */}

        <Wrapper>
          <div>
            <div className="title">
              <Flex align="center" gap={10}>
                {isCode && size === 1 ? (
                  ''
                ) : (
                  <Avatar
                    shape="square"
                    icon={<CarOutlined style={{ fontSize: 14 }} />}
                    size={25}
                    style={{ background: '#521e9b' }}
                  />
                )}
                <Typography.Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksOptionsKanbanList.enRouteText')}
                </Typography.Title>
              </Flex>
              <Tag color="#521e9b">
                {tasksEnRouteTotal}{' '}
                {translate('TasksOptionsKanbanList.tasksText')}
              </Tag>
            </div>
          </div>

          <InfiniteScroll
            dataLength={taskEnRoute.length}
            hasMore={taskEnRoute.length !== tasksEnRouteTotal}
            next={loadDataEnRoute}
            loader={<LoadingOutlined />}
            scrollableTarget="scrollableDiv"
            height={'70vh'}
          >
            <Board isCode={isCode && size === 1}>
              <div className="cards">
                {taskEnRoute?.map((taskStatus) => (
                  <CardsKanban
                    taskStatusData={taskStatus}
                    key={taskStatus._id}
                  />
                ))}
              </div>
            </Board>
          </InfiniteScroll>
        </Wrapper>

        <Wrapper>
          <div>
            <div className="title">
              <Flex align="center" gap={10}>
                {isCode && size === 1 ? (
                  ''
                ) : (
                  <Avatar
                    shape="square"
                    icon={<ToolOutlined style={{ fontSize: 14 }} />}
                    size={25}
                    style={{ background: '#088b55' }}
                  />
                )}
                <Typography.Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksOptionsKanbanList.workingText')}
                </Typography.Title>
              </Flex>
              <Tag color="#088b55">
                {tasksWorkingTotal}{' '}
                {translate('TasksOptionsKanbanList.tasksText')}
              </Tag>
            </div>
          </div>

          <InfiniteScroll
            dataLength={taskWorking.length}
            hasMore={taskWorking.length !== tasksWorkingTotal}
            next={loadDataWorking}
            loader={<LoadingOutlined />}
            scrollableTarget="scrollableDiv"
            height={'70vh'}
          >
            <Board isCode={isCode && size === 1}>
              <div className="cards">
                {taskWorking?.map((taskStatus) => (
                  <CardsKanban
                    taskStatusData={taskStatus}
                    key={taskStatus._id}
                  />
                ))}
              </div>
            </Board>
          </InfiniteScroll>
        </Wrapper>

        {isColumns?.columns ? (
          <Wrapper>
            <div>
              <div className="title" id="finished">
                <Flex align="center" gap={10}>
                  {isCode && size === 1 ? (
                    ''
                  ) : (
                    <Avatar
                      shape="square"
                      icon={<CheckCircleOutlined style={{ fontSize: 14 }} />}
                      size={25}
                      style={{ background: '#0f4b83' }}
                    />
                  )}
                  <Typography.Title level={5} style={{ marginBottom: 0 }}>
                    {translate('TasksOptionsKanbanList.finishedText')}
                  </Typography.Title>
                </Flex>
                <Tag color="#0f4b83">
                  {tasksFinishedTotal}{' '}
                  {translate('TasksOptionsKanbanList.tasksText')}
                </Tag>
              </div>
            </div>

            <InfiniteScroll
              dataLength={taskFinished.length}
              hasMore={taskFinished.length !== tasksFinishedTotal}
              next={loadDataFinished}
              loader={<LoadingOutlined />}
              scrollableTarget="scrollableDiv"
              height={'70vh'}
            >
              <Board isCode={isCode && size === 1}>
                <div className="cards">
                  {taskFinished?.map((taskStatus) => (
                    <CardsKanban
                      taskStatusData={taskStatus}
                      key={taskStatus._id}
                    />
                  ))}
                </div>
              </Board>
            </InfiniteScroll>
          </Wrapper>
        ) : (
          ''
        )}

        {!isColumns?.columns ? (
          <>
            <Wrapper>
              <div>
                <div className="title">
                  <Flex align="center" gap={10}>
                    {isCode && size === 1 ? (
                      ''
                    ) : (
                      <Avatar
                        shape="square"
                        icon={<CoffeeOutlined style={{ fontSize: 14 }} />}
                        size={25}
                        style={{ background: '#fa8c16' }}
                      />
                    )}
                    <Typography.Title level={5} style={{ marginBottom: 0 }}>
                      {translate('TasksOptionsKanbanList.breakText')}
                    </Typography.Title>
                  </Flex>
                  <Tag color="#fa8c16">
                    {tasksBreakTotal}{' '}
                    {translate('TasksOptionsKanbanList.tasksText')}
                  </Tag>
                </div>
              </div>

              <InfiniteScroll
                dataLength={taskBreak.length}
                hasMore={taskBreak.length !== tasksBreakTotal}
                next={loadDataBreak}
                loader={<LoadingOutlined />}
                scrollableTarget="scrollableDiv"
                height={'70vh'}
              >
                <Board isCode={isCode && size === 1}>
                  <div className="cards">
                    {taskBreak?.map((taskStatus) => (
                      <CardsKanban
                        taskStatusData={taskStatus}
                        key={taskStatus._id}
                      />
                    ))}
                  </div>
                </Board>
              </InfiniteScroll>
            </Wrapper>
            <Wrapper>
              <div>
                <div className="title">
                  <Flex align="center" gap={10}>
                    {isCode && size === 1 ? (
                      ''
                    ) : (
                      <Avatar
                        shape="square"
                        icon={<CloseCircleOutlined style={{ fontSize: 14 }} />}
                        size={25}
                        style={{ background: '#ce151e' }}
                      />
                    )}
                    <Typography.Title level={5} style={{ marginBottom: 0 }}>
                      {translate('TasksOptionsKanbanList.canceledText')}
                    </Typography.Title>
                  </Flex>
                  <Tag color="#ce151e">
                    {tasksCanceledTotal}{' '}
                    {translate('TasksOptionsKanbanList.tasksText')}
                  </Tag>
                </div>
              </div>

              <InfiniteScroll
                dataLength={taskCanceled.length}
                hasMore={taskCanceled.length !== tasksCanceledTotal}
                next={loadDataCanceled}
                loader={<LoadingOutlined />}
                scrollableTarget="scrollableDiv"
                height={'70vh'}
              >
                <Board isCode={isCode && size === 1}>
                  <div className="cards">
                    {taskCanceled?.map((taskStatus) => (
                      <CardsKanban
                        taskStatusData={taskStatus}
                        key={taskStatus._id}
                      />
                    ))}
                  </div>
                </Board>
              </InfiniteScroll>
            </Wrapper>

            <Wrapper>
              <div>
                <div className="title">
                  <Flex align="center" gap={10}>
                    {isCode && size === 1 ? (
                      ''
                    ) : (
                      <Avatar
                        shape="square"
                        icon={<CheckCircleOutlined style={{ fontSize: 14 }} />}
                        size={25}
                        style={{ background: '#0f4b83' }}
                      />
                    )}
                    <Typography.Title level={5} style={{ marginBottom: 0 }}>
                      {translate('TasksOptionsKanbanList.finishedText')}
                    </Typography.Title>
                  </Flex>
                  <Tag color="#0f4b83">
                    {tasksFinishedTotal}{' '}
                    {translate('TasksOptionsKanbanList.tasksText')}
                  </Tag>
                </div>
              </div>

              <InfiniteScroll
                dataLength={taskFinished.length}
                hasMore={taskFinished.length !== tasksFinishedTotal}
                next={loadDataFinished}
                loader={<LoadingOutlined />}
                scrollableTarget="scrollableDiv"
                height={'70vh'}
              >
                <Board isCode={isCode && size === 1}>
                  <div className="cards">
                    {taskFinished?.map((taskStatus) => (
                      <CardsKanban
                        taskStatusData={taskStatus}
                        key={taskStatus._id}
                      />
                    ))}
                  </div>
                </Board>
              </InfiniteScroll>
            </Wrapper>
          </>
        ) : (
          ''
        )}
      </Boards>
    </Container>
  )
}

export default ListKanban
